import { Controller } from "@hotwired/stimulus"
import Sortable from "sortablejs"

export default class extends Controller {
  static values = {
    url: String
  }

  connect() {
    this.sortable = Sortable.create(this.element, {
      animation: 150,
      easing: "cubic-bezier(0.25, 0.46, 0.45, 0.94)", // easeOutQuad - snappier
      handle: ".handle",
      ghostClass: "sortable-ghost",
      chosenClass: "sortable-chosen",
      dragClass: "sortable-drag",
      // Prevent drag from starting on interactive elements
      filter: "button, form, input, select, a, .btn",
      preventOnFilter: false, // Allow clicks to pass through to filtered elements
      // Enable touch support
      forceFallback: true, // Required for consistent touch behavior
      fallbackTolerance: 5, // Prevents accidental drags
      touchStartThreshold: 5, // Minimum movement before drag starts
      delay: 150, // Slight delay helps distinguish tap from drag on mobile
      delayOnTouchOnly: true, // Only apply delay on touch devices
      swapThreshold: 0.65, // Makes drop zone more responsive
      invertSwap: true, // Better swap behavior
      direction: "vertical",
      onStart: this.start.bind(this),
      onEnd: this.end.bind(this)
    })
  }

  start(event) {
    // Add visual feedback when dragging starts
    event.item.style.opacity = "0.5"
  }

  end(event) {
    // Reset opacity
    event.item.style.opacity = "1"

    // Get all service IDs in new order
    const ids = Array.from(this.element.children).map(item => item.dataset.id)

    // Send to server
    fetch(this.urlValue, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": document.querySelector("[name='csrf-token']").content
      },
      body: JSON.stringify({ services: ids })
    })
    .then(response => {
      if (response.ok) {
        // Show brief success feedback
        this.showFeedback("Order saved!")
      }
    })
    .catch(error => {
      console.error("Error saving order:", error)
    })
  }

  showFeedback(message) {
    // Create temporary feedback element
    const feedback = document.createElement("div")
    feedback.textContent = message
    feedback.className = "fixed bottom-4 right-4 bg-green-600 text-white px-4 py-2 rounded-lg shadow-lg z-50 animate-fade-in"
    document.body.appendChild(feedback)

    // Remove after 2 seconds
    setTimeout(() => {
      feedback.classList.add("animate-fade-out")
      setTimeout(() => feedback.remove(), 300)
    }, 2000)
  }

  disconnect() {
    this.sortable.destroy()
  }
}
